<template>
  <q-page class="bg-grey-1">
    <q-dialog v-model="mpkModal.state.show" :persistent="false">
      <DeviationDelayMPKModal v-if="mpkModal.state.show" />
    </q-dialog>
    <q-dialog v-model="delayModal.state.show" :persistent="false">
      <DeviationDelayModal v-if="delayModal.state.show" />
    </q-dialog>
    <q-dialog v-model="opalModal.state.show" :persistent="false">
      <DeviationDelayMPKMultipleModal v-if="opalModal.state.show" />
    </q-dialog>

    <q-toolbar class="bg-white q-pl-none">
      <q-btn stretch flat no-caps @click="toggleShowHeader">
        <q-icon :name="showHeader ? 'mdi-chevron-up' : 'mdi-chevron-down'" />
        <span class="text-caption q-ml-sm">{{
          showHeader ? 'Dölj navigering' : 'Visa navigering'
        }}</span>
      </q-btn>
      <template v-if="activeSearchMode === 'trainSearch'">
        <q-separator vertical />
        <q-btn
          stretch
          flat
          @click="() => (showCirculations = !showCirculations)"
          no-caps
        >
          <q-icon
            :name="showCirculations ? 'mdi-chevron-up' : 'mdi-chevron-down'"
          />
          <span class="text-caption q-ml-sm">{{
            showCirculations ? 'Dölj omlopp' : 'Visa omlopp'
          }}</span>
        </q-btn>
      </template>
      <q-separator vertical class="q-mr-md" />
      <q-btn-toggle
        v-model="activeSearchMode"
        dense
        no-caps
        padding="2px 12px"
        toggle-color="primary"
        :options="[
          { label: 'Tågsök', value: 'trainSearch' },
          { label: 'Platssök', value: 'placeSearch' },
        ]"
      />
      <q-separator vertical class="q-mx-md" />
      <template v-if="activeSearchMode === 'trainSearch'">
        <q-input
          borderless
          dense
          type="number"
          label="Tågnummer"
          v-model="tempTrainNumber"
          @blur="onSearchTrainNumber"
          @change="onSearchTrainNumber"
          @keyup.enter="onSearchTrainNumber"
        >
          <template #prepend>
            <q-icon class="q-mr-md" size="16px" name="mdi-train" />
          </template>
        </q-input>
      </template>

      <template v-if="activeSearchMode === 'placeSearch'">
        <q-input
          style="width: 100px"
          borderless
          dense
          label="Från"
          v-model="tempPlaceSearchModal.from"
          @blur="onSearchTrainNumber"
          @change="onSearchTrainNumber"
          @keyup.enter="onSearchTrainNumber"
        >
          <template #prepend>
            <q-icon class="q-mr-md" size="16px" name="mdi-map-marker-outline" />
          </template>
        </q-input>
        <q-input
          style="width: 120px"
          borderless
          dense
          label="Till"
          v-model="tempPlaceSearchModal.to"
          @blur="onSearchTrainNumber"
          @change="onSearchTrainNumber"
          @keyup.enter="onSearchTrainNumber"
        >
          <template #prepend>
            <div class="q-mt-sm">
              <q-btn fab flat padding="4px" @click="toggleLocation">
                <q-icon
                  class="q-mr-md"
                  size="16px"
                  name="mdi-swap-horizontal"
                />
              </q-btn>
            </div>
          </template>
        </q-input>
        <q-separator vertical class="q-mr-md" />
        <q-select
          style="width: 160px"
          v-model="model.via"
          @new-value="createViaValue"
          use-input
          use-chips
          multiple
          hide-dropdown-icon
          input-debounce="0"
          dense
          borderless
          label="Via"
          @blur="onSearchTrainNumber"
        />
      </template>

      <q-separator vertical class="q-mr-md" />

      <q-input
        type="date"
        :model-value="model.departureDate"
        @change="onDepartureDateChange"
        borderless
        dense
        label="Avgångsdatum"
      >
      </q-input>

      <template v-if="activeSearchMode === 'placeSearch'">
        <q-separator vertical class="q-mx-md" />
        <q-select
          style="width: 130px"
          v-model="placeSearchHours"
          dense
          borderless
          label="Tidsperiod"
          map-options
          emit-value
          :options="[
            { label: '00-03', value: [0, 3] },
            { label: '03-06', value: [3, 6] },
            { label: '06-09', value: [6, 9] },
            { label: '09-12', value: [9, 12] },
            { label: '12-15', value: [12, 15] },
            { label: '15-18', value: [15, 18] },
            { label: '18-21', value: [18, 21] },
            { label: '21-24', value: [21, 24] },
          ]"
        />
      </template>

      <q-space />

      <q-separator vertical class="q-mr-sm" />
      <q-select
        borderless
        class="q-ml-md"
        style="width: 120px"
        v-model="grafMode"
        :options="[
          { label: 'Planerat', value: 'planned' },
          { label: 'Utfall', value: 'actual' },
          { label: 'Alla', value: 'all' },
        ]"
        option-label="label"
        option-value="value"
        map-options
        emit-value
        dense
        square
        stretch
        label="Grafläge"
      />
      <q-separator vertical class="q-ml-md" />
      <q-toggle v-model="simulated" label="Simulerat" />
      <q-separator vertical class="q-ml-md" />
      <q-toggle v-model="showOpal" label="Visa opal varningar" />
      <q-separator vertical class="q-ml-md" />
      <q-btn-toggle
        dense
        square
        stretch
        flat
        no-caps
        v-model="timelineZoomMode"
        toggle-color="primary"
        padding="4px 8px"
        :options="[
          { label: '1 min', value: 'minutes' },
          { label: '5 min', value: '5 minutes' },
        ]"
      />
      <q-separator vertical class="q-ml-md" />
      <q-btn stetch flat :loading="refreshLoading" @click="onRefresh"
        ><q-icon size="18px" name="mdi-refresh"
      /></q-btn>
    </q-toolbar>
    <q-separator />

    <q-linear-progress indeterminate v-if="loading" />

    <div class="row q-col-gutter-xs q-pa-xs">
      <div class="col-12">
        <div class="row q-mb-xs" v-if="showCirculations">
          <div class="col-12">
            <GraphCirculation />
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <GraphView />
          </div>
        </div>
      </div>
    </div>
  </q-page>
</template>

<script lang="ts">
import { computed, defineComponent, provide, ref, watch } from 'vue'
import GraphView from '@/components/graph/GraphView.vue'
import GraphCirculation from '@/components/graph/GraphCirculation.vue'
import { useGraph } from '@/composable/useGraph'
import { useApp } from '@/composable/useApp'
import DeviationDelayMPKModal from '@/components/deviation/deviation-delay/DeviationDelayMPKModal.vue'
import DeviationDelayMPKMultipleModal from '@/components/deviation/deviation-delay/DeviationDelayMPKMultipleModal.vue'
import { useModal } from '@/composable/useModal'
import { getMpkEvent } from '@/api/mpk/getMpkEvent'
import { searchDelay } from '@/api/search/searchDelay'
import { searchPrevTripFromTraind } from '@/api/search/prevTripFromTraind'
import DeviationDelayModal from '@/components/deviation/DeviationDelayModal.vue'
import { useGraphCirculation } from '@/composable/useGraphCirculation'
import { MpkEventMessageData } from '@/api/graph/getMpkEventMessage'
import { useRoute } from 'vue-router'
import type { QSelectProps } from 'quasar'

export default defineComponent({
  components: {
    GraphView,
    GraphCirculation,
    DeviationDelayMPKModal,
    DeviationDelayModal,
    DeviationDelayMPKMultipleModal,
  },

  setup() {
    const opalModal = useModal()
    const mpkModal = useModal()
    const delayModal = useModal()
    provide('opal-modal', opalModal)
    provide('delay-mpk-modal', mpkModal)
    provide('delay-modal-2', delayModal)
    const {
      model,
      events,
      showCirculations,
      timelineZoomMode,
      grafMode,
      showOpal,
      simulated,
      loading: loadingGraph,
      refresh,
      setSelectedTrainNumber,
      activeSearchMode,
      placeSearchHours,
    } = useGraph()
    const { loading: loadingCirculation } = useGraphCirculation()
    const { showHeader } = useApp()
    const route = useRoute()

    const tempTrainNumber = ref(model.value.trainNumber)
    const tempPlaceSearchModal = ref({
      from: model.value.from,
      to: model.value.to,
    })

    watch(
      () => model.value.trainNumber,
      (value) => {
        tempTrainNumber.value = value
      }
    )

    if (
      typeof route.query.from === 'string' &&
      typeof route.query.to === 'string'
    ) {
      model.value.from = route.query.from
      model.value.to = route.query.to
      tempPlaceSearchModal.value.from = route.query.from
      tempPlaceSearchModal.value.to = route.query.to
    }

    if (typeof route.query.via === 'string' && route.query.via.length) {
      model.value.via = route.query.via.split(',')
    }

    const onSearchTrainNumber = () => {
      model.value.trainNumber = tempTrainNumber.value
      model.value.from = tempPlaceSearchModal.value.from
      model.value.to = tempPlaceSearchModal.value.to
    }

    const onDepartureDateChange = (v: string) => {
      if (v.length !== 10) return
      model.value.departureDate = v
    }

    const toggleShowHeader = () => {
      showHeader.value = !showHeader.value
    }

    events.mpk_cb = (mpk_event_id: string) => {
      const eventId = mpk_event_id.split(' ')[0].replace('H', '')
      mpkModal?.openModal({
        cb: async (setData) => {
          await getMpkEvent(eventId)
            .then(({ data }) => {
              setData({
                eventId,
                mpkData: data,
              })
            })
            .catch((error) => {
              setData(error.response.data.message)
            })

          return Promise.resolve()
        },
      })
    }

    events.opal_cb = (mpkMessageData: MpkEventMessageData[]) => {
      opalModal?.openModal({
        cb: async (setData) => {
          setData({
            mpkMessageData,
          })
        },
      })
    }

    events.delay_cb = (advertised: string, departureDate: string) => {
      delayModal?.openModal({
        cb: async (setData) => {
          const params = {
            technical: advertised,
            departureDate: departureDate,
          }
          await Promise.all([
            searchDelay(params),
            searchPrevTripFromTraind({
              tnr: parseInt(params.technical, 10),
              date: params.departureDate,
            }),
          ])
            .then(([{ data }, { data: prevTripFromTraind }]) => {
              setData({
                data,
                prevTripFromTraind,
                technical: params.technical,
                departure: params.departureDate,
              })
            })
            .catch((error) => {
              setData(error.response.data.message)
            })

          return Promise.resolve()
        },
      })
    }

    const loading = computed(() => {
      return loadingGraph.value || loadingCirculation.value
    })

    const refreshLoading = ref(false)

    const onRefresh = async () => {
      refreshLoading.value = true
      await refresh()
      refreshLoading.value = false
    }

    watch(placeSearchHours, () => {
      setSelectedTrainNumber(model.value.trainNumber, model.value.departureDate)
    })

    watch(activeSearchMode, () => {
      setSelectedTrainNumber(model.value.trainNumber, model.value.departureDate)
    })

    const createViaValue: QSelectProps['onNewValue'] = (val, done) => {
      if (val.length > 0) {
        done(val.toLowerCase(), 'add-unique')
      }
    }

    const toggleLocation = () => {
      const from = tempPlaceSearchModal.value.from
      const to = tempPlaceSearchModal.value.to
      tempPlaceSearchModal.value.from = to
      tempPlaceSearchModal.value.to = from
      onSearchTrainNumber()
    }

    return {
      onSearchTrainNumber,
      tempTrainNumber,
      model,
      onDepartureDateChange,
      toggleShowHeader,
      showHeader,
      mpkModal,
      delayModal,
      showCirculations,
      timelineZoomMode,
      grafMode,
      loading,
      opalModal,
      showOpal,
      simulated,
      onRefresh,
      refreshLoading,
      activeSearchMode,
      tempPlaceSearchModal,
      placeSearchHours,
      createViaValue,
      toggleLocation,
    }
  },
})
</script>
